exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-pagination{display:-webkit-box;display:-ms-flexbox;display:flex}.ds-pagination .el-pagination{width:100%}", ""]);

// exports
